import { render, staticRenderFns } from "./DeliveryOrder.vue?vue&type=template&id=511f41f4&scoped=true&"
import script from "./DeliveryOrder.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrder.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrder.vue?vue&type=style&index=0&id=511f41f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511f41f4",
  null
  
)

export default component.exports